<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50 mb-10">
			<div>
				<label class="h6 display-block">
					현장명
					<input v-model="item.project_name" class="input-box radius-20 width-100 mt-10" placeholder="현장명을 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					작업 기간

					<div class="justify-space-between gap-10 items-center mt-10">
						<input v-model="item.sDate" class="input-box radius-20  flex-1" placeholder="시작일 입력하세요" maxlength="20" lang="ko" type="date"/>
						~
						<input v-model="item.eDate" class="input-box radius-20  flex-1" placeholder="종료일 입력하세요" maxlength="20" lang="ko" type="date"/>
					</div>
				</label>

				<label class="h6 display-block mt-10">
					현장내용
				</label>

				<div class="mt-10 box pa-10 radius-10">
					<template
						v-if="items_file.length > 0"
					>
						<label
							v-for="(file, f_index) in items_file"
							:key="'file_' + f_index"
							class="justify-space-between items-center"
						>
							<a
								:href="file.file_path"
								target="project_file"
								class="width-100 inline-block justify-space-between items-center"
							>{{ file.original_name }} <v-icon>mdi mdi-download-box</v-icon></a>
							<button
								@click="deleteFile(file)"
							><v-icon>mdi mdi-close-box</v-icon></button>
						</label>
					</template>
					<div
						v-else
					>첨부파일이 없습니다.</div>
				</div>


				<label class="display-block mt-10 input-box full-width radius-10">
					<v-icon
						class="color-icon"
					>mdi mdi-image</v-icon>
					{{ file_name }}
					<input
						v-show="false"
						type="file"
						placeholder="대표 이미지"
						class="input-box "
						maxlength="250"
						@change="setFile"
						accept="image/*, application/pdf"
					/>
				</label>

				<textarea
					v-model="item.project_content"
					class="input-box radius-20 width-100 mt-10"
					placeholder="현장내용 입력하세요"
					lang="ko">
				</textarea>
			</div>

			<div>

				<label class="h6 display-block mt-10">
					작업 인원
				</label>

				<div>
					<ul>
						<template
							v-for="member in items_member"
						>
						<li
							:key="member.member_id"
							class="box radius-20 pa-10 mt-10 justify-space-between gap-10 items-center"
							:class="{'box-primary':member.status == '1'  }"
							@click="setStatus(member)"
						>
							{{ member.member_name }} ( {{ member.member_id }} )

							<button
								v-if="member.member_id != user.member_id"
							>
								<v-icon
									v-if="member.status == '1'"
									class="color-primary"
									large
								>mdi mdi-toggle-switch</v-icon>
								<v-icon
									v-else
									large
								>mdi mdi-toggle-switch-off</v-icon>
							</button>
						</li>
						</template>
					</ul>
				</div>
			</div>
		</div>
		<div
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="putProject"
			>저장</button>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ProjectDetail'
	, props: ['user']
	, data: function(){
		return {
			program: {
				name: '현장 상세 정보'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {

			}
			, project_idx: this.$route.params.idx
			, items_member: []
			, items_file: []
		}
	}
	, computed: {
		file_name: function(){
			let t = '첨부파일을 선택하세요'

			if(this.item.b_file){
				t = this.item.b_file.name
			}

			return t
		}
	}
	, methods: {
		putProject: async function(){
			this.$bus.$emit('on', true)
			try {

				this.$set(this.item, 'project_member', JSON.stringify(this.items_member))
				const result = await this.$request.init({
					method: 'post'
					, url: 'project/putProject'
					, data: this.item
				})

				if(result.success){
					this.$bus.$emit('notify', { type: 'success', message: result.message})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProject'
					, data: {
						idx: this.project_idx
					}
				})

				if(result.success){
					this.item = result.data.project_info
					this.items_member = result.data.member_list
					this.items_file = result.data.files
					this.$bus.$emit('notify', { type: 'success', message: result.message})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, setStatus: async function(member_info){

			if(Number(member_info.member_level) < 3){

				if(member_info.member_id != this.user.member_id){
					this.$set(member_info, 'status', member_info.status == '1' ? member_info.status = '0' : member_info.status = '1')
				}

				this.$bus.$emit('on', true)
				try {
					const result = await this.$request.init({
						method: 'post'
						, url: 'project/putProjectMemberStatus'
						, data: {
							idx: this.project_idx
							, member_id: member_info.member_id
							, status: member_info.status
						}
					})

					if(result.success){
						//
					}else{
						throw result.message
					}
				}catch (e){
					this.$bus.$emit('notify', { type: 'error', message: e})
				}finally {
					this.$bus.$emit('on', false)
				}

			}
		}
		, deleteFile: async function(file){
			try {

				if(confirm("해당 파일을 삭제하시겠습니까?")){
					const result = await this.$request.init({
						method: 'post'
						, url: 'project/deleteFile'
						, data: {
							idx: file.uid
						}
					})

					if(result.success){
						await this.getData()
					}else{
						throw result.message
					}
				}

			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		,setFile: function(e){
			let file = e.target.files[0]
			this.$set(this.item, 'b_file', file)
		}
	}
	, created() {
		if(this.user.member_level < 3){
			this.$bus.$emit('to', {name: 'ProjectView', params: { idx: this.project_idx}})
		}else{
			this.$bus.$emit('onLoad', this.program)
			this.getData()
		}
	}
}
</script>